import { CommonCalendarButtonUi } from 'common/components/entities/Calendar/calendar-step/ui/common-calendar-button-ui'
import { PaidCalendarPaymentButtonProps } from 'common/types/entities/booking-paid-calendar-interface'
import FieldErrors from 'publisher/components/FieldErrors'
import useSecureAndPayPaymentHandler from 'publisher/hooks/payment/useSecureAndPayPaymentHandler'
import useManagement, {
  selectors as managementSelectors,
} from 'publisher/hooks/useManagement'
import React from 'react'

export const PaidCalendarSecureAndPayPaymentButton = ({
  entity,
  commonStyles,
}: PaidCalendarPaymentButtonProps) => {
  const { isLoading, handleSubmit, errors } =
    useSecureAndPayPaymentHandler(entity)

  const isPreview = useManagement(managementSelectors.isPreviewMode)

  return (
    <React.Fragment>
      <CommonCalendarButtonUi
        backgroundColor={entity.selectedSlotBackgroundColor}
        onClick={handleSubmit}
        disabled={isLoading || isPreview}
        {...commonStyles}
      >
        {entity.formButtonText}
      </CommonCalendarButtonUi>
      <FieldErrors errors={errors} />
    </React.Fragment>
  )
}
